export default "__VITE_ASSET__Ios18Jt___"